import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  AcademicCapIcon,
  CalendarIcon,
  ChartBarIcon,
  GiftIcon,
  PowerIcon,
  BanknotesIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';
import logo from '../assets/images/logo.svg';
import TopUpModal from './TopUpModal';
import { useTranslations } from '../hooks/useTranslations';
import EarningsNotification from './EarningsNotification';

function Sidebar() {
  const [showTopUpModal, setShowTopUpModal] = useState(false);
  const location = useLocation();
  const { t } = useTranslations();

  const navigation = [
    { name: t('sidebar.dashboard'), icon: HomeIcon, path: '/dashboard' },
    { name: t('sidebar.activateAccount'), icon: PowerIcon, path: '/activate' },
    { name: t('sidebar.topUp'), icon: BanknotesIcon, onClick: () => setShowTopUpModal(true) },
    { name: t('sidebar.education'), icon: AcademicCapIcon, path: '/education' },
    // { name: 'Экономический календарь', icon: CalendarIcon, path: '/calendar' },
    { name: t('sidebar.tradingCenter'), icon: ChartBarIcon, path: '/trading' },
    { name: t('sidebar.bonuses'), icon: GiftIcon, path: '/bonuses' },
  ];

  return (
    <>
      <div className="w-64 p-4 flex-col md:flex hidden">
        <div className="mb-8">
          <a href="/">
            <img src={logo} alt={t('sidebar.logoAlt')} className="h-8" />
          </a>
        </div>
        
        <nav className="space-y-2.5">
          {navigation.map((item) => (
            item.onClick ? (
              <button
                key={item.name}
                onClick={item.onClick}
                className={`group flex items-center px-4 py-3.5 rounded-2xl relative transition-all duration-300 ${
                  location.pathname === item.path
                    ? 'bg-white shadow-[0_4px_20px_rgba(0,0,0,0.05)] before:absolute before:left-0 before:top-4 before:bottom-4 before:w-[3px] before:bg-primary before:rounded-full'
                    : ' '
                }`}>
                <div className={`p-2 rounded-xl mr-3 transition-colors duration-300 ${
                  location.pathname === item.path ? 'bg-primary/20' : 'bg-transparent group-hover:bg-primary/20'
                }`}>
                  <item.icon className={`h-[18px] w-[18px] transition-colors duration-300 ${
                    location.pathname === item.path ? 'text-[#277B6F]' : 'text-[#98A8B1] group-hover:text-[#277B6F]'
                  }`} />
                </div>
                <span className={`text-[14px] font-medium transition-colors duration-300 ${
                  location.pathname === item.path ? 'text-black' : 'text-[#98A8B1] group-hover:text-black'
                }`}>
                  {item.name}
                </span>
              </button>
            ) : (
              <Link
                key={item.name}
                to={item.path}
                className={`group flex items-center px-4 py-3.5 rounded-2xl relative transition-all duration-300 ${
                  location.pathname === item.path
                    ? 'bg-white shadow-[0_4px_20px_rgba(0,0,0,0.05)] before:absolute before:left-0 before:top-4 before:bottom-4 before:w-[3px] before:bg-primary before:rounded-full'
                    : ' '
                }`}>
                <div className={`p-2 rounded-xl mr-3 transition-colors duration-300 ${
                  location.pathname === item.path ? 'bg-primary/20' : 'bg-transparent group-hover:bg-primary/20'
                }`}>
                  <item.icon className={`h-[18px] w-[18px] transition-colors duration-300 ${
                    location.pathname === item.path ? 'text-[#277B6F]' : 'text-[#98A8B1] group-hover:text-[#277B6F]'
                  }`} />
                </div>
                <span className={`text-[14px] font-medium transition-colors duration-300 ${
                  location.pathname === item.path ? 'text-black' : 'text-[#98A8B1] group-hover:text-black'
                }`}>
                  {item.name}
                </span>
              </Link>
            )
          ))}
        </nav>
        <EarningsNotification />
      </div>

      <TopUpModal 
        isOpen={showTopUpModal} 
        onClose={() => setShowTopUpModal(false)} 
      />
    </>
  );
}

export default Sidebar; 